module.exports = __webpack_public_path__ + "img/webeditor-1.ead273d4.png";